import { PRODUCT_PAGE_REACT_QUERY_241007 } from "@faire/web-api/indigofair/settings/PRODUCT_PAGE_REACT_QUERY_241007";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingProductPageReactQuery = (): boolean => {
  return getSettingValueWithoutAssignment(
    PRODUCT_PAGE_REACT_QUERY_241007,
    false
  );
};
